import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=c8f6d1e0&scoped=true&"
var script = {}
import style0 from "./Tabs.vue?vue&type=style&index=0&id=c8f6d1e0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f6d1e0",
  null
  
)

export default component.exports